import { jsx } from '@emotion/react';
import { Styles } from './Styles.es.js';

const SymbolSize20 = () => {
  return jsx(
    "svg",
    { css: Styles.root, width: "20", height: "20", "data-testid": "ZapierLogoSymbolSmall", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    jsx("rect", { width: "20", height: "20", rx: "3", fill: "#FF4F00" })
  );
};

export { SymbolSize20 };
//# sourceMappingURL=SymbolSize20.es.js.map
